import { theme } from './theme';

export const device = {
  mobile: `(min-width: ${theme.breakpoints.sm.width}px)`,
  tablet: `(min-width: ${theme.breakpoints.md.width}px)`,
  desktop: `(min-width: ${theme.breakpoints.lg.width}px)`,
  pageLimit: `(min-width: ${theme.pageLimit({ theme })}px)`,
};
